import { useState } from 'react';
import PropTypes from 'prop-types';
import { Tab } from '@headlessui/react';
import LargeModal from '../../components/Modal/LargeModal';
import IconTrash from "../../components/Icon/IconTrash";

const CreateShipmentLabelModal = ({
                               open, onClose, orderId, requestLabel
                           }) => {

    const [boxData, setBoxData] = useState([
        {
            id: '1',
            length: '14.75',
            width: '14.75',
            height: '3.25',
            weight: '0',
        }
    ]);

    const onCloseButtonClickHandler = () => {
        onClose();
    };

    function handleBoxValueChange(event, sampleIndex) {
        console.log(event, sampleIndex);
    }

    const handleAddBox = () => {
        setBoxData([
            ...boxData,
            {
                id: boxData.length + 1,
                length: '14.75',
                width: '14.75',
                height: '3.25',
                weight: '0',
            }
        ]);
    };

    const handleDeleteBox = (index) => {
        setBoxData(boxData.filter((_, i) => i !== index));
    };

    return (
        <LargeModal open={open} setOpen={onCloseButtonClickHandler}>
            <div>
                <Tab.Group>
                    <Tab.Panels>
                        <h2 className="font-bold pb-4">Order Details</h2>

                        <div className="flex flex-row w-full text-white text-sm pt-4 h-16">
                            <div className="w-[15%] flex justify-center items-center bg-[#0d3857] border-solid border-r-2 border-white group relative cursor-pointer">
                                <h2 className="text-center">Box #</h2>
                            </div>
                            <div className="w-[15%] flex justify-center items-center bg-[#0d3857] border-solid border-r-2 border-white group relative cursor-pointer">
                                <h2 className="text-center">length (Inch)</h2>
                            </div>
                            <div className="w-[15%] flex justify-center items-center bg-[#0d3857] border-solid border-r-2 border-white group relative cursor-pointer">
                                <h2 className="text-center">width (Inch)</h2>
                            </div>
                            <div className="w-[15%] flex justify-center items-center bg-[#0d3857] border-solid border-r-2 border-white group relative cursor-pointer">
                                <h2 className="text-center">Height (Inch)</h2>
                            </div>
                            <div className="w-[15%] flex justify-center items-center bg-[#0d3857] border-solid border-r-2 border-white group relative cursor-pointer">
                                <h2 className="text-center">Weight (LB)</h2>
                            </div>
                            <div className="w-[25%] flex justify-center items-center bg-[#0d3857] border-solid border-r-2 border-white group relative cursor-pointer">
                                <h2 className="text-center">Action</h2>
                            </div>
                        </div>

                        {boxData.map((item, boxIndex) => (
                            <div className="flex flex-row w-full h-auto text-xs">
                                <div className="w-[15%] flex justify-center items-center bg-[#f3f6f7] border-solid border-r-2 border-b-2 border-white p-2">
                                    <input
                                        type="string"
                                        className="w-full h-auto text-center rounded font-bold border-solid border-2 border-black p-2"
                                        placeholder="Box #"
                                        onChange={(e) => {
                                            const newData = [...boxData];
                                            newData[boxIndex].id = e.target.value;
                                            setBoxData(newData);
                                        }}
                                        value={item.id}
                                    />
                                </div>
                                <div className="w-[15%] flex justify-center items-center bg-[#f3f6f7] border-solid border-r-2 border-b-2 border-white p-2">
                                    <input
                                        type="string"
                                        className="w-full h-auto text-center rounded font-bold border-solid border-2 border-black p-2"
                                        placeholder="Box Length"
                                        onChange={(e) => {
                                            const newData = [...boxData];
                                            newData[boxIndex].length = e.target.value;
                                            setBoxData(newData);
                                        }}
                                        value={item.length}
                                    />
                                </div>
                                <div className="w-[15%] flex justify-center items-center bg-[#f3f6f7] border-solid border-r-2 border-b-2 border-white p-2">
                                    <input
                                        type="string"
                                        className="w-full h-auto text-center rounded font-bold border-solid border-2 border-black p-2"
                                        placeholder="Box Width"
                                        onChange={(e) => {
                                            const newData = [...boxData];
                                            newData[boxIndex].width = e.target.value;
                                            setBoxData(newData);
                                        }}
                                        value={item.width}
                                    />
                                </div>
                                <div className="w-[15%] flex justify-center items-center bg-[#f3f6f7] border-solid border-r-2 border-b-2 border-white p-2">
                                    <input
                                        type="string"
                                        className="w-full h-auto text-center rounded font-bold border-solid border-2 border-black p-2"
                                        placeholder="Box Height"
                                        onChange={(e) => {
                                            const newData = [...boxData];
                                            newData[boxIndex].height = e.target.value;
                                            setBoxData(newData);
                                        }}
                                        value={item.height}
                                    />
                                </div>
                                <div className="w-[15%] flex justify-center items-center bg-[#f3f6f7] border-solid border-r-2 border-b-2 border-white p-2">
                                    <input
                                        type="string"
                                        className="w-full h-auto text-center rounded font-bold border-solid border-2 border-black p-2"
                                        placeholder="Box Weight"
                                        onChange={(e) => {
                                            const newData = [...boxData];
                                            newData[boxIndex].weight = e.target.value;
                                            setBoxData(newData);
                                        }}
                                        value={item.weight}
                                    />
                                </div>
                                <div className="w-[25%] flex justify-center items-center bg-[#f3f6f7] border-solid border-r-2 border-b-2 border-white p-2">
                                    <button
                                        type="submit"
                                        className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
                                        onClick={() => handleDeleteBox(boxIndex)}
                                    >
                                        <IconTrash />
                                    </button>
                                </div>
                            </div>
                        ))}
                    </Tab.Panels>
                </Tab.Group>
            </div>
            <div className="flex flex-row justify-end pt-2">
                <button
                    type="submit"
                    className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
                    onClick={handleAddBox}
                >
                    Add Box
                </button>
                <button
                    type="submit"
                    className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
                    onClick={() => requestLabel(boxData, orderId)}
                >
                    Submit
                </button>
            </div>
        </LargeModal>
    );
};

CreateShipmentLabelModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    orderId: PropTypes.string.isRequired,
    requestLabel: PropTypes.func.isRequired,
};

export default CreateShipmentLabelModal;
